<app-spinner-service></app-spinner-service>

<app-toolbar-search 
  [showDateFilters]="true" 
  [showDownloadButton]="true" 
  [showSingleDate]="true"
  [(date)]="periodo"
  (onDateChange)="onDateChange()" 
  (onDownload)="downloadExcel()"
  (onSearch)="applyFilterGlobal($event)" 
  placeholder="Pesquisar DRE...">
</app-toolbar-search>

<p-table #dt 
  [value]="objectKeys(dre)" 
  [paginator]="true" 
  [rows]="50"
  [globalFilterFields]="[]"
  currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros"
  class="custom-table"
  [loading]="loading"
  [showCurrentPageReport]="true"
  [rowsPerPageOptions]="[5, 10, 20, 50]">

  <ng-template pTemplate="header">
    <tr>
      <th pSortableColumn="descricao" style="width: 70%">
        Descrição <p-sortIcon field="descricao"></p-sortIcon>
      </th>
      <th pSortableColumn="valor" style="width: 30%">
        Valor <p-sortIcon field="valor"></p-sortIcon>
      </th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-key>
    <tr>
      <td>
        <div class="description-content">
          <i class="pi pi-align-left description-icon"></i>
          <span class="description-text" [ngClass]="{ 'bold-text': isBold(key) }" [pTooltip]="getDreTitle(key)" tooltipPosition="top">{{ getDreTitle(key) }}</span>
        </div>
      </td>
      <td>
        <div class="value-content">
          <i class="pi pi-dollar value-icon"></i>
          <span class="value-text" [ngClass]="{ 'bold-text': isBold(key) }" [pTooltip]="dre[key] | currency:'BRL':'symbol'" tooltipPosition="top">{{ dre[key] | currency:'BRL':'symbol' }}</span>
        </div>
      </td>
    </tr>
  </ng-template>

  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="2" class="empty-message">
        <div class="empty-content">
          <i class="pi pi-chart-line" style="font-size: 3rem; color: #6c757d; margin-bottom: 1rem;"></i>
          <h3>Nenhum DRE encontrado</h3>
          <p>Não há dados de DRE para o período selecionado.</p>
        </div>
      </td>
    </tr>
  </ng-template>
</p-table>

<div class="p-d-flex p-jc-end" style="margin-top: 1%;">
  <button pButton label="Voltar" icon="pi pi-arrow-left" class="p-button-secondary" (click)="voltar()"></button>
</div>